import React from 'react'
import {
  Grid,
  FormControl,
  InputLabel,
  TextField,
  MenuItem,
  Select,
  FormHelperText,
} from '@material-ui/core'
export default function WMemoField({data, onChange, tabActive}) {
  return (
    <Grid item xs={6}>
      <FormControl fullWidth variant="outlined" className="ap-textfield" style={{width: 320}}>
        <InputLabel id="demo-mutiple-name-label">{data.name}</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          label={data.name}
          value={data.value || [data?.default_value] || []}
          onChange={e => {
            onChange(e, data.key)
          }}
          multiple
        >
          {data?.description?.split('!#!').map(f => {
            return <MenuItem value={f}>{f}</MenuItem>
          })}
        </Select>
        <FormHelperText>
          {(() => {
            if (
              (tabActive === 'upcoming' && data.is_required) ||
              (tabActive === 'ongoing' && data.is_required_return)
            ) {
              return 'required*'
            } else {
              return 'optional'
            }
          })()}
        </FormHelperText>
      </FormControl>
    </Grid>
  )
}
